export function haversineKm(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

// The homepage hero. A Pexels photograph (docs/pexels-homepage-2026-09-22.md
// names the picture, the photographer and the licence), rendered at four
// widths in public/assets by tools/upload_pexels_homepage.py --hero. The alt
// says what is in the frame and nothing more: it is a real beach, not a
// listed club, and the words must not suggest otherwise.
export const HERO_IMAGE = {
  base: "/assets/hero-loungers",
  widths: [960, 1440, 1920, 2400] as const,
  width: 2400,
  height: 1350,
  alt: "Rows of empty sun loungers and closed parasols on a wide sandy beach at Rethymno, Crete, early in the day",
} as const;

export const heroSrc = (w: (typeof HERO_IMAGE.widths)[number]) => `${HERO_IMAGE.base}-${w}.webp`;

export const REGION_CARDS = [
  { key: "sicily", label: "Sicily", image: "/assets/region-sicily-800.webp" },
  { key: "sardinia", label: "Sardinia", image: "/assets/region-sardinia-800.webp" },
  { key: "ibiza", label: "Ibiza", image: "/assets/region-ibiza-800.webp" },
  { key: "algarve", label: "Algarve", image: "/assets/region-algarve-800.webp" },
  { key: "mykonos-santorini", label: "Mykonos & Santorini", image: "/assets/region-greece-800.webp" },
  { key: "cote-azur", label: "Côte d'Azur", image: "/assets/region-cote-azur-800.webp" },
] as const;
